import { IPostWidgetStyle } from "@pageBuilder/typings";
import { CssProperties } from "../../../models/css-property";
import { WidgetAnimationRenderer } from "../widget-animation.renderer";
import { ElementStyleService } from "../../../services/element-style.service";

export class BlogPostStylesRenderer {

    protected readonly animationRenderer: WidgetAnimationRenderer;

    constructor(private readonly styleService: ElementStyleService) {
        this.animationRenderer = new WidgetAnimationRenderer(styleService);
    }

    public render(element: HTMLElement, style?: IPostWidgetStyle | null): void {
        if (!style) {
            this.cleanup(element);
            return;
        }

        const contentProperties = new CssProperties();
        contentProperties.tryAdd("--heading-color", style.headingsColor ?? "");
        contentProperties.tryAdd("--subheading-color", style.subheadingColor ?? "");
        contentProperties.tryAdd("--normal-text-color", style.normalTextColor ?? "");
        contentProperties.tryAdd("--categories-font-weight", style.categoriesFont?.weight ?? "");
        contentProperties.tryAdd("--categories-font-family", style.categoriesFont?.family ?? "");
        contentProperties.tryAdd("--metadata-font-weight", style.metadataFont?.weight ?? "");
        contentProperties.tryAdd("--metadata-font-family", style.metadataFont?.family ?? "");
        contentProperties.tryAdd("--tags-font-weight", style.tagsFont?.weight ?? "");
        contentProperties.tryAdd("--tags-font-family", style.tagsFont?.family ?? "");

        this.styleService.setStyle(element, `#${element.id} .widget-content`, contentProperties.data);

        const blogPostWrapperProps = new CssProperties();
        blogPostWrapperProps.tryAdd("border", `${style.borderWidth}px solid ${style.borderColor}`);
        blogPostWrapperProps.tryAdd("padding", `${style.padding}px`);
        blogPostWrapperProps.tryAdd("background-color", style.postBackground);
        this.styleService.setStyle(element, `#${element.id} .blog-post-wrapper`, blogPostWrapperProps.data);

        this.animationRenderer.setAnimationStyles(element, style.animation);
    }

    public cleanup(element: HTMLElement): void {
        const selectors = this.getStyleSelectors(element);
        selectors.forEach(selector => {
            this.styleService.clearStyle(element, selector);
        });
    }

    public getStyleSelectors(element: HTMLElement): string[] {
        return [
            `#${element.id}`,
            `#${element.id} .widget-content`,
            `#${element.id} .blog-post-wrapper`,
            `#${element.id} .items-nav`,
            `#${element.id} .blog-post-wrapper .metadata`,
            `#${element.id} .blog-post-wrapper .tags`
        ];
    }

}
